module.exports = __webpack_public_path__ + "img/logo.c37b5950.png";